const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

/**
 * Obtiene un token de Cloudflare Turnstile para los formularios que hacen POST
 * al endpoint público /contact (la lambda contactForm lo verifica en servidor).
 *
 * ⚠️ Los tokens son de UN SOLO USO: hay que pedir uno nuevo en cada submit,
 * nunca cachearlos (misma lección que el chat público, ver useChatWebSocket.js).
 *
 * Devuelve '' si Turnstile no está disponible (script bloqueado, sin site key,
 * timeout): el formulario debe enviar igualmente y es el backend quien decide.
 */
export async function getTurnstileToken() {
  if (typeof window === 'undefined' || !window.turnstile || !TURNSTILE_SITE_KEY) return '';

  return new Promise((resolve) => {
    let settled = false;
    const done = (token) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(token || '');
    };
    // Si Cloudflare no responde, no dejamos el formulario colgado
    const timer = setTimeout(() => done(''), 15000);

    try {
      window.turnstile.execute(TURNSTILE_SITE_KEY, {
        callback: done,
        'error-callback': () => done(''),
        'expired-callback': () => done(''),
      });
    } catch {
      try {
        let container = document.getElementById('turnstile-form-container');
        if (!container) {
          container = document.createElement('div');
          container.id = 'turnstile-form-container';
          container.style.display = 'none';
          document.body.appendChild(container);
        } else {
          try { window.turnstile.remove(container); } catch { /* ignore */ }
        }
        window.turnstile.render(container, {
          sitekey: TURNSTILE_SITE_KEY,
          callback: done,
          'error-callback': () => done(''),
          'expired-callback': () => done(''),
        });
      } catch {
        done('');
      }
    }
  });
}
